import gql from 'graphql-tag';
import accessoryTargetFields from '@/queries/fields/accessoryTargetFields';

const accessoryFields = gql`
  fragment accessoryFields on Accessory {
    id
    floorId
    discoveredAt
    creationDate
    name
    type
    modelId
    isProtected
    macAddress
    position {
      id
      coordX
      coordY
    }
    accessoryTargets {
      ...accessoryTargetFields
    }
  }
  ${accessoryTargetFields}
`;

export default accessoryFields;
